export default __webpack_public_path__ + "static/media/avatar_123.c6a775a5.png";